import { userApi } from './client';
import type { User, AuthResponse } from '@/types';

export const authService = {
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await userApi.post<AuthResponse>('/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  async register(email: string, password: string): Promise<AuthResponse> {
    const response = await userApi.post<AuthResponse>('/auth/register', {
      email,
      password,
    });
    return response.data;
  },

  async getMe(): Promise<User> {
    const response = await userApi.get<User>('/auth/me');
    return response.data;
  },

  async updateMe(data: Partial<Pick<User, 'language'>>): Promise<User> {
    const response = await userApi.patch<User>('/auth/me', data);
    return response.data;
  },

  async refreshToken(refreshToken: string): Promise<AuthResponse> {
    const response = await userApi.post<AuthResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },

  async logout(): Promise<void> {
    await userApi.post('/auth/logout');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  },

  async sendVerificationCode(
    email: string,
    purpose: 'login' | 'register' | 'reset_password'
  ): Promise<{ message: string; expires_in: number }> {
    const response = await userApi.post('/auth/send-code', {
      type: 'email',
      target: email,
      purpose,
    });
    return response.data;
  },

  async verifyCode(
    email: string,
    code: string,
    purpose: 'login' | 'register' | 'reset_password'
  ): Promise<AuthResponse> {
    const response = await userApi.post<AuthResponse>('/auth/verify-code', {
      type: 'email',
      target: email,
      code,
      purpose,
    });
    return response.data;
  },

  // Telegram-specific auth
  async telegramAuth(initData: string): Promise<AuthResponse> {
    const response = await userApi.post<AuthResponse>('/auth/telegram', {
      init_data: initData,
    });
    return response.data;
  },
};

export default authService;
